import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { ValidateIf } from 'class-validator'
import { isEmpty } from 'lodash'
import { parseFloatNumber, parseIntNumber } from '@core/services/csv/CSVTransformer'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = new DateService()

export class NavWrapTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'Adviser Code' = 'CODE 123'

  get advCode () {
    return this['Adviser Code']
  }

  @Expose()
  private 'Adviser' = 'Wen Adviser'

  get advName () {
    return this.Adviser
  }

  @Expose()
  @IsNotEmpty()
  private 'Account Number' = 'Policy 123'

  get policyNumber () {
    return this['Account Number']
  }

  @Expose()
  private 'Primary Client Name' = 'Client Name'

  get clientName () {
    return this['Primary Client Name']
  }

  @Expose()
  private 'Plan Structure' = 'Life Insurance Name'

  get planType () {
    return this['Plan Structure']
  }

  @Expose()
  private 'Aviva Fund Code' = 'Aviva Fund Code'

  get componentCode () {
    return this['Aviva Fund Code']
  }

  @Expose()
  private 'Fund Name' = 'Life Insurance Name'

  get productName () {
    return this['Fund Name']
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumCurrency))
  @IsOneOfThese(['SGD', 'CHF', 'EUR', 'GBP', 'USD', 'AUD', 'JPY', 'HKD'])
  private 'Contact Currency' = 'SGD'

  get premiumCurrency () {
    return this['Contact Currency']
  }

  private 'Investment amount/average value' = 0

  get premiumAmt () {
    return this['Investment amount/average value']
  }

  @Expose()
  @Transform(({ value }) => parseIntNumber(value))
  @ValidateIf(o => !isEmpty(o.exchangeRate))
  @IsNumber()
  private 'FX Rate' = 1

  get exchangeRate () {
    return this['FX Rate']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.paidToDate))
  @IsValidDate('DD/MM/YYYY')
  private 'Trade Date' = '31/12/2020'

  get paidToDate (): number {
    return dateService.toUnixMilliseconds(this['Trade Date'], 'DD/MM/YYYY')
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Net Remuneration before GST SGD amount' = 123.45

  get commissionAmt () {
    return this['Net Remuneration before GST SGD amount']
  }

  private 'Or Amt' = 0

  get orCommissionAmt () {
    return this['Or Amt']
  }

  @Expose()
  private 'Remuneration Type' = 'Overriding'

  get remark () {
    return this['Remuneration Type']
  }
}
